export default __webpack_public_path__ + "static/media/965.9d5e8ef1.jpg";